import { useEffect } from "react";
import { HiOutlineCheckCircle, HiOutlineExclamationCircle, HiOutlineX } from "react-icons/hi";
import { detailToMessage } from "../utils/apiError";

function Toast({ message, type = "success", onClose, duration = 4000 }) {
 useEffect(() => {
 const timer = setTimeout(() => {
 onClose();
 }, duration);
 return () => clearTimeout(timer);
 }, [onClose, duration]);

 const styles = {
 success: {
 bg: "bg-white border-[#e5e7eb]",
 icon: "text-[#16a34a]",
 text: "text-[#24292f]",
 close: "text-[#8b949e] hover:text-[#57606a]",
 },
 error: {
 bg: "bg-white border-red-200",
 icon: "text-red-600",
 text: "text-[#24292f]",
 close: "text-[#8b949e] hover:text-[#57606a]",
 },
 };

 const s = styles[type] || styles.success;
 const Icon = type === "error" ? HiOutlineExclamationCircle : HiOutlineCheckCircle;
 // Callers occasionally pass a raw API error payload (a 422 `detail` array, say). Rendering
 // that object would take the whole page down, so it is flattened to text here as well.
 const text =
 typeof message === "string" || typeof message === "number"
 ? message
 : detailToMessage(message, "Something went wrong");

 return (
 <div className="fixed top-6 right-6 z-[300] animate-[slideIn_0.3s_ease-out]">
 <div
 className={`flex items-center gap-3 px-5 py-3.5 rounded-lg border shadow-[0_8px_24px_rgba(0,0,0,0.12)] ${s.bg} min-w-[320px] max-w-md`}
 >
 <Icon className={`text-xl flex-shrink-0 ${s.icon}`} />
 <p className={`m-0 text-sm font-medium flex-1 ${s.text}`}>{text}</p>
 <button
 className={`flex-shrink-0 bg-transparent border-none cursor-pointer p-0.5 rounded-lg transition-colors ${s.close}`}
 onClick={onClose}
 >
 <HiOutlineX className="text-base" />
 </button>
 </div>
 </div>
 );
}

export default Toast;
